import { useEffect, useState } from 'react';
import {
    Button,
    FormControl,
    Input,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
} from '@chakra-ui/react';

export interface ConfirmMakeTagModalProps {
    isOpen: boolean;
    /** Seed value when lookup found a make. */
    makeName?: string | null;
    onConfirm: (makeName: string) => void;
    onCancel?: () => void;
}

const ConfirmMakeTagModal = ({
    isOpen,
    makeName,
    onConfirm,
    onCancel,
}: ConfirmMakeTagModalProps) => {
    const [enteredMake, setEnteredMake] = useState('');

    useEffect(() => {
        if (!isOpen) return;
        setEnteredMake(makeName?.trim() ?? '');
    }, [isOpen, makeName]);

    const trimmedEntered = enteredMake.trim();
    const canConfirm = Boolean(trimmedEntered);

    const handleConfirm = () => {
        if (!trimmedEntered) return;
        onConfirm(trimmedEntered);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel ?? (() => {})}
            size="md"
            isCentered
            closeOnOverlayClick
            closeOnEsc={false}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900" pb={1}>
                    Confirm Make
                </ModalHeader>
                <ModalBody pt={0} pb={4}>
                    <FormControl>
                        <Text fontSize="sm" color="gray.600" mb={2}>
                            Confirm the make to add as a tag.
                        </Text>
                        <Input
                            value={enteredMake}
                            onChange={(e) => setEnteredMake(e.target.value)}
                            placeholder="e.g. Honda"
                            autoFocus
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' && canConfirm) {
                                    e.preventDefault();
                                    handleConfirm();
                                }
                            }}
                        />
                    </FormControl>
                </ModalBody>
                <ModalFooter>
                    <Button
                        size="action"
                        bg="#4051B5"
                        color="white"
                        _hover={{ bg: '#3544a0' }}
                        onClick={handleConfirm}
                        isDisabled={!canConfirm}
                    >
                        Confirm
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmMakeTagModal;
